import styled from 'styled-components';

// Współdzielony wzorzec „rozwijanego wiersza" (expanded row) — szczegóły pozycji
// renderują się inline pod wierszem tabeli zamiast w modalu. Używane na:
// Dashboard (CurrentOrderList), /order-products, /product-rental-reservations.

// Reguły wstrzykiwane do styled-component `ListTable` (analogicznie do recentRowCss):
// wąska kolumna z chevronem + podświetlenie aktualnie rozwiniętego wiersza.
// Tło neutralne (slate z przezroczystością), żeby czytać się na jasnym i ciemnym
// motywie. Wstrzykuj PRZED `recentRowCss`, żeby podświetlenie „świeżego" wiersza
// (amber) miało pierwszeństwo nad podświetleniem rozwinięcia.
export const expandableRowCss = `
  tbody td.chevron {
    width: 34px;
    text-align: center;
    padding-left: 0;
  }
  tbody tr.is-expanded td {
    background: rgba(148, 163, 184, 0.1);
  }
`;

// Wiersz-kontener na panel ze szczegółami (renderowany pod klikniętym wierszem).
export const ExpandedRow = styled.tr`
  &:hover { background: transparent !important; cursor: default !important; }
`;

// Komórka rozciągnięta na całą szerokość tabeli (colSpan = liczba kolumn).
export const ExpandedDetailCell = styled.td`
  padding: 0 !important;
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.02)' : '#f8fafc')};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
`;

// Wewnętrzny wrapper z paddingiem i delikatną animacją rozwijania.
export const ExpandedInner = styled.div`
  padding: 14px 16px 18px;
  animation: expandRowIn 0.2s ease;

  @keyframes expandRowIn {
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

// Placeholder „Ładowanie…" pokazywany, gdy dane szczegółów są dociągane async.
export const ExpandLoadingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

// Chevron w ostatniej kolumnie — obraca się o 180° gdy wiersz jest rozwinięty.
export const ChevronToggle = styled.span<{ $open: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: transform 0.2s ease;
  transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};

  svg { width: 16px; height: 16px; }
`;
